import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllStainList,CreateStain,UpdateStain,DeleteStain} from '../../services/micro/micro'

export const useStain = () => {

    const [createSweet] = useSweetAlert();
    const [listBacteriumCount, setListBacteriumCount] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchListBacteriumCount, setSearchListBacteriumCount] = useState([])

    // ? MODAL CRUD
    const [modal, setModal] = useState(false)
    const [tittle, setTittle] = useState("")
    const [method, setMethod] = useState("")
    const [id_resistance, setId_resistance] = useState(0);
    const [titleDelete, setTitleDelete] = useState("");

    // ? Alert Modal
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    // ? search 
    const [searchStain, setSearchStain] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);

    // * FORM 
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name:"",
    });

    const {
        name,
    } = formValues;
   
    useEffect(() => {
        getBacteriumCount()
    }, []);
    
    const getBacteriumCount = async (_type) =>
        {
            const resistance = await getAllStainList();    

            if (resistance?.length > 0)
            {
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;
                let _new_list = [];

                endItems = aux;
                startItems = endItems - numberItems;

                resistance.forEach((_find,_key) => {
                    let posicion = _key + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
                    _new_list.push({
                        id_mic_stain: _find?.id_mic_stain ?? null,
                        name: _find?.name ?? null,
                        visibleTable: visibleTable,
                    })
                });
                setListBacteriumCount(_new_list);      
                setSearchListBacteriumCount(_new_list)              
            }
    }

    const openDialog = (title, mode) => {
        setTittle(title);
        setMethod(mode);
        setModal(true);
    };
    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);
        setShowDeleteAlert(false);
    };

    // * CRUD TABLE
    const handleCreate = () => 
    {        
        handleUpdateValues({
            name:"",
        })
        setMethod("create")
        openDialog("Crear Tinsion", "create")
    }

    const saveCreate =async (e) => 
    {
        e.preventDefault();
        
        setLoading(true);
        const response = await CreateStain({
            name: formValues.name,  
        });

        if (response.code === 200){
            setLoading(false);
            getBacteriumCount()
            createSweet("success", "success", "Se a creado correctamente");
            closeDialog();
            handleUpdateValues({
                name:"",
            })
        } 
    }

    const handleUpdate = (id_mic_stain) => 
    {
        let list = listBacteriumCount.find(c => c.id_mic_stain === parseInt(id_mic_stain));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list?.name,
            });
            setId_resistance(id_mic_stain)
            setMethod("update")
            openDialog("Actualizar Tinsion", "create")
        }
    }

    const saveUpdateBacterium = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        const response = await UpdateStain({
            id_mic_stain: id_resistance,
            name: formValues.name,   
        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                getBacteriumCount()
                closeDialog();
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    const handleDelete = (id_mic_stain,_name) => 
    {
        let list = listBacteriumCount.find(c => c.id_mic_stain === parseInt(id_mic_stain));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list.name,
            });
            setTitleDelete(list.name)
            setId_resistance(id_mic_stain)
            setMethod("delete")
            openDeleteAlert();
        }
    }

    const saveDeleteBacterium= async (e) => 
    {
        e.preventDefault();
    
        setLoading(true);
    
        const response = await DeleteStain({
            id_mic_stain : id_resistance
        });
    
        if (response.code === 200){
            setLoading(false);
            createSweet("success", "success", "Se a eliminado correctamente");
            closeDeleteAlert();
            getBacteriumCount()
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    // ? PAGINATION 
    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listBacteriumCount.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listcompanies = [];
        listBacteriumCount.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcompanies.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListBacteriumCount(listcompanies);

    }, [totalPageCount, currentPage]);
   
    // ? SEARCH TYPE DISCOUNT
    const handleSearch = (e) => {
        setSearchStain(e);

        let busqueda = e.toUpperCase();
        let newMethod = [];

        searchListBacteriumCount.forEach(element => {

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setListBacteriumCount(newMethod);
    }

      const handleClearStain = () => {
        setSearchStain("");                         
        localStorage.removeItem("globalFilter");    
        setListBacteriumCount(searchListBacteriumCount);                    
    };

      const handleExportExcelStain = async () => {
        setLoadingExport(true);
        try {
            const XLSX = await import("xlsx");

          const _report = listBacteriumCount.map((item, index) => ({
                "#": index + 1,
                Tenciones: item.name ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Tinciones");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_tincion.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };



    return {
        // * LIST
        listBacteriumCount,

        // * PAGINATION
        totalPageCount, currentPage, nextPage, previousPage, goToPage,

        //* CRUD TABLE
        handleCreate,handleUpdate,handleDelete,method,modal,tittle,
        name,handleInputChange,titleDelete,
        saveCreate,saveUpdateBacterium,saveDeleteBacterium,loading,

        handleExportExcelStain,

        //* SEARCH
        handleSearch, handleClearStain, searchStain, loadingExport, 

        //*DIALOG
        closeDeleteAlert, closeDialog,
        showDeleteAlert, modalAlert, 
    }
}
